import React from "react";

import { IOptionCode } from "../../../models/catalogue.interfaces";
import { slugify } from "../../../utils/text";
import { useAppSelector } from "../../reducers";
import { getOptionValueSet } from "../utils";

interface IProps {
    attributeCode: IOptionCode;
    attributeValue: string;
    content: string;
}

export const PDPSelectedVariantConditionalBlock = (
    props: IProps,
): React.ReactNode => {
    const selectedValues = useAppSelector(
        (state) => state.configurator.ui.optionValues,
    );

    // If the currently selected value of the configured attribute doesn't match the desired value, don't render anything
    const optionValueSet = getOptionValueSet(
        selectedValues[props.attributeCode],
    );
    const isSelected = optionValueSet.has(props.attributeValue);

    // Build IDs for relationship to tab controls. These IDs must match the IDs used by PDPChangeVariantOptionBlock.
    const tabControlID = slugify(
        `change-variant-block-${props.attributeCode}-${props.attributeValue}`,
    );
    const tabPanelID = slugify(
        `variant-conditional-block-${props.attributeCode}-${props.attributeValue}`,
    );

    return (
        <div
            id={tabPanelID}
            role="tabpanel"
            aria-labelledby={tabControlID}
            aria-hidden={!isSelected}
            style={{ display: isSelected ? "block" : "none" }}
            dangerouslySetInnerHTML={{ __html: props.content }}
        ></div>
    );
};
